// Auto-import SASS generated CSS
import './index.css';

export type {AlertProps} from './Alert';
export {alertTypes, default as default} from './Alert';
